import { render, staticRenderFns } from "./TimeSlotsUpdate.vue?vue&type=template&id=0a41d820&scoped=true"
import script from "./TimeSlotsUpdate.vue?vue&type=script&lang=js"
export * from "./TimeSlotsUpdate.vue?vue&type=script&lang=js"
import style0 from "./TimeSlotsUpdate.vue?vue&type=style&index=0&id=0a41d820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a41d820",
  null
  
)

export default component.exports